import React from 'react';
import styles from './styles';
import DataTable from '../../DataTable';
import {TrialCache} from '../../TrialCache';
import getTrialUiHeaders from '../../TrialUI/Hooks/getHeaders';
import {useHistory, useLocation} from 'react-router-dom';
import {InstanceContext} from '../../../InstanceContext';
import {UserContext} from '../../../Context/UserContext';
import { trackActivity } from '../../../utils/activityTracker'


const PatientsLandingPage = props => {
  const {cache} = React.useContext(TrialCache);
  const {user} = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);
  const history = useHistory();
  const location = useLocation();
  const data = cache.xpertTriage_po_all.data;
  const headers = getTrialUiHeaders(['patName', 'patEmail', 'platform', 'studyTitle', 'nct_link', 'studyStatus', 'dateRegistered', 'comments']);
  const trialInstance = contextInstance || user.instance;

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  return(
    <div style={styles.container}>
      <DataTable
        headerSettings={headers}
        data={data}
        options={{
          customTopOffset: '45px',
          cellSettingsButton: { onClick: () => { console.log('settings button clicked'); handleActivityLogUpdate(`PatientsLandingPage.handleActivityLogUpdate`) } }
        }}
        cellRoute={'/' + trialInstance + '/user/overview/dtdata:_id'}
        routeState={{title: 'Overview'}}
        history={history}
        location={location}
      />
    </div>
  )
}

export default PatientsLandingPage;
